import { SupabaseClientOptions, createClient } from '@supabase/supabase-js'

const options: SupabaseClientOptions<'public'> = {
    global: {
        headers: {
            Authorization: `Bearer ${process.env.GATSBY_SUPABASE_API_KEY ?? ''}`,
        },
    },
}

const supabase = createClient(
    process.env.GATSBY_SUPABASE_URL ?? '',
    process.env.GATSBY_SUPABASE_API_KEY ?? '',
    options,
)

export default supabase
